import {Row} from "react-bootstrap";
import stylesProfiloUtente from "../../../components/profiloUtente/ProfiloUtente.module.css";
import Icon from "../../../components/icon/Icon";
import orologioIcon from "../../../img/icons/clock_102733.png";
import React, {useEffect, useState} from "react";
import stylesElencoSportelli from "../ElencoSportelli.module.css";
import Button from "../../../components/Button/Button";
import oggettiUtili from "../../../utils/OggettiUtili.json"

function ModaleOrari(props) {

    const [sportello, setSportello] = useState({nomeSportello: "", orari: {}, appuntamento: "", note: ""})

    useEffect(() => {
        setSportello(props.sportelloConOrari)
    }, [props.sportelloConOrari])

    function onClickIndietro() {
        setSportello({nomeSportello: "", orari: {}, appuntamento: "", note: ""})
    }

    return (
        <div style={{marginBottom: "1rem"}}>
            <div className={"row"} style={{alignItems: "center"}}>
                <div className="col-1">
                    <div className={stylesProfiloUtente.avatarPiccoloDiv}>
                        {/* Decorativa: il nome dello sportello adiacente e' il contenuto informativo. */}
                        <Icon path={orologioIcon} height="30px" width="30px" alt={""}/>
                    </div>
                </div>
                <div className="col-8">
                    <span style={{fontWeight: "bold", fontSize: "22px"}}>{sportello.nomeSportello}</span>
                </div>
            </div>
            {sportello.appuntamento?<div>
                <div className={"row"}>
                    <div className="col-1"></div>
                    <div className="col-11">
                        <span style={{fontWeight: "bold", fontSize: "20px"}}>Orari:&nbsp;</span>
                        <span className={stylesElencoSportelli.stileFont}>Ricevimento solo su appuntamento</span>
                    </div>
                </div>
                <div className={"row"}>
                    <div className="col-1"></div>
                    <div className="col-10">
                        <span style={{fontWeight: "bold", fontSize: "20px"}}>Note:&nbsp;</span>
                        <span style={{overflowWrap: "anywhere"}}
                              className={stylesElencoSportelli.stileFont}>{sportello.note}</span>
                    </div>
                </div>
            </div>:<></>}
            {sportello.orari?<div>
                <Row style={{marginTop: "15px"}}>
                    <div className="col-2"/>
                    <div className="col-5" style={{textAlign: "center"}}>
                        <span style={{fontSize: "18px", fontStyle: "oblique"}}>Mattina</span>
                    </div>
                    <div className="col-5" style={{textAlign: "center"}}>
                        <span style={{fontSize: "18px", fontStyle: "oblique"}}>Pomeriggio</span>
                    </div>
                </Row>
                <Row style={{marginTop: "5px"}}>
                    <div className="col-2">
                        <span className={stylesElencoSportelli.stileFont}>Lunedì</span>
                    </div>
                    <div className={"col-5"}>
                        <div className="row" style={{justifyContent: "space-around"}}>
                            <div className="col-5" style={{border: "1px solid #1b7ea9", textAlign: "center"}}>
                                <span>{sportello.orari.lunediMattina1 ? oggettiUtili.orariPerCodice[sportello.orari.lunediMattina1] : "//"}</span>
                            </div>
                            <div className="col-5" style={{border: "1px solid #1b7ea9", textAlign: "center"}}>
                                <span>{sportello.orari.lunediMattina2 ? oggettiUtili.orariPerCodice[sportello.orari.lunediMattina2] : "//"}</span>
                            </div>
                        </div>
                    </div>
                    <div className={"col-5"}>
                        <div className="row" style={{justifyContent: "space-around"}}>
                            <div className="col-5" style={{border: "1px solid #1b7ea9", textAlign: "center"}}>
                                <span>{sportello.orari.lunediPomeriggio1 ? oggettiUtili.orariPerCodice[sportello.orari.lunediPomeriggio1] : "//"}</span>
                            </div>
                            <div className="col-5" style={{border: "1px solid #1b7ea9", textAlign: "center"}}>
                                <span>{sportello.orari.lunediPomeriggio2 ? oggettiUtili.orariPerCodice[sportello.orari.lunediPomeriggio2] : "//"}</span>
                            </div>
                        </div>
                    </div>
                </Row>
                <Row style={{marginTop: "5px"}}>
                    <div className="col-2">
                        <span className={stylesElencoSportelli.stileFont}>Martedì</span>
                    </div>
                    <div className={"col-5"}>
                        <div className="row" style={{justifyContent: "space-around"}}>
                            <div className="col-5" style={{border: "1px solid #1b7ea9", textAlign: "center"}}>
                                <span>{sportello.orari.martediMattina1 ? oggettiUtili.orariPerCodice[sportello.orari.martediMattina1] : "//"}</span>
                            </div>
                            <div className="col-5" style={{border: "1px solid #1b7ea9", textAlign: "center"}}>
                                <span>{sportello.orari.martediMattina2 ? oggettiUtili.orariPerCodice[sportello.orari.martediMattina2] : "//"}</span>
                            </div>
                        </div>
                    </div>
                    <div className={"col-5"}>
                        <div className="row" style={{justifyContent: "space-around"}}>
                            <div className="col-5" style={{border: "1px solid #1b7ea9", textAlign: "center"}}>
                                <span>{sportello.orari.martediPomeriggio1 ? oggettiUtili.orariPerCodice[sportello.orari.martediPomeriggio1] : "//"}</span>
                            </div>
                            <div className="col-5" style={{border: "1px solid #1b7ea9", textAlign: "center"}}>
                                <span>{sportello.orari.martediPomeriggio2 ? oggettiUtili.orariPerCodice[sportello.orari.martediPomeriggio2] : "//"}</span>
                            </div>
                        </div>
                    </div>
                </Row>
                <Row style={{marginTop: "5px"}}>
                    <div className="col-2">
                        <span className={stylesElencoSportelli.stileFont}>Mercoledì</span>
                    </div>
                    <div className={"col-5"}>
                        <div className="row" style={{justifyContent: "space-around"}}>
                            <div className="col-5" style={{border: "1px solid #1b7ea9", textAlign: "center"}}>
                                <span>{sportello.orari.mercolediMattina1 ? oggettiUtili.orariPerCodice[sportello.orari.mercolediMattina1] : "//"}</span>
                            </div>
                            <div className="col-5" style={{border: "1px solid #1b7ea9", textAlign: "center"}}>
                                <span>{sportello.orari.mercolediMattina2 ? oggettiUtili.orariPerCodice[sportello.orari.mercolediMattina2] : "//"}</span>
                            </div>
                        </div>
                    </div>
                    <div className={"col-5"}>
                        <div className="row" style={{justifyContent: "space-around"}}>
                            <div className="col-5" style={{border: "1px solid #1b7ea9", textAlign: "center"}}>
                                <span>{sportello.orari.mercolediPomeriggio1 ? oggettiUtili.orariPerCodice[sportello.orari.mercolediPomeriggio1] : "//"}</span>
                            </div>
                            <div className="col-5" style={{border: "1px solid #1b7ea9", textAlign: "center"}}>
                                <span>{sportello.orari.mercolediPomeriggio2 ? oggettiUtili.orariPerCodice[sportello.orari.mercolediPomeriggio2] : "//"}</span>
                            </div>
                        </div>
                    </div>
                </Row>
                <Row style={{marginTop: "5px"}}>
                    <div className="col-2">
                        <span className={stylesElencoSportelli.stileFont}>Giovedì</span>
                    </div>
                    <div className={"col-5"}>
                        <div className="row" style={{justifyContent: "space-around"}}>
                            <div className="col-5" style={{border: "1px solid #1b7ea9", textAlign: "center"}}>
                                <span>{sportello.orari.giovediMattina1 ? oggettiUtili.orariPerCodice[sportello.orari.giovediMattina1] : "//"}</span>
                            </div>
                            <div className="col-5" style={{border: "1px solid #1b7ea9", textAlign: "center"}}>
                                <span>{sportello.orari.giovediMattina2 ? oggettiUtili.orariPerCodice[sportello.orari.giovediMattina2] : "//"}</span>
                            </div>
                        </div>
                    </div>
                    <div className={"col-5"}>
                        <div className="row" style={{justifyContent: "space-around"}}>
                            <div className="col-5" style={{border: "1px solid #1b7ea9", textAlign: "center"}}>
                                <span>{sportello.orari.giovediPomeriggio1 ? oggettiUtili.orariPerCodice[sportello.orari.giovediPomeriggio1] : "//"}</span>
                            </div>
                            <div className="col-5" style={{border: "1px solid #1b7ea9", textAlign: "center"}}>
                                <span>{sportello.orari.giovediPomeriggio2 ? oggettiUtili.orariPerCodice[sportello.orari.giovediPomeriggio2] : "//"}</span>
                            </div>
                        </div>
                    </div>
                </Row>
                <Row style={{marginTop: "5px"}}>
                    <div className="col-2">
                        <span className={stylesElencoSportelli.stileFont}>Venerdì</span>
                    </div>
                    <div className={"col-5"}>
                        <div className="row" style={{justifyContent: "space-around"}}>
                            <div className="col-5" style={{border: "1px solid #1b7ea9", textAlign: "center"}}>
                                <span>{sportello.orari.venerdiMattina1 ? oggettiUtili.orariPerCodice[sportello.orari.venerdiMattina1] : "//"}</span>
                            </div>
                            <div className="col-5" style={{border: "1px solid #1b7ea9", textAlign: "center"}}>
                                <span>{sportello.orari.venerdiMattina2 ? oggettiUtili.orariPerCodice[sportello.orari.venerdiMattina2] : "//"}</span>
                            </div>
                        </div>
                    </div>
                    <div className={"col-5"}>
                        <div className="row" style={{justifyContent: "space-around"}}>
                            <div className="col-5" style={{border: "1px solid #1b7ea9", textAlign: "center"}}>
                                <span>{sportello.orari.venerdiPomeriggio1 ? oggettiUtili.orariPerCodice[sportello.orari.venerdiPomeriggio1] : "//"}</span>
                            </div>
                            <div className="col-5" style={{border: "1px solid #1b7ea9", textAlign: "center"}}>
                                <span>{sportello.orari.venerdiPomeriggio2 ? oggettiUtili.orariPerCodice[sportello.orari.venerdiPomeriggio2] : "//"}</span>
                            </div>
                        </div>
                    </div>
                </Row>
                <Row style={{marginTop: "5px"}}>
                    <div className="col-2">
                        <span className={stylesElencoSportelli.stileFont}>Sabato</span>
                    </div>
                    <div className={"col-5"}>
                        <div className="row" style={{justifyContent: "space-around"}}>
                            <div className="col-5" style={{border: "1px solid #1b7ea9", textAlign: "center"}}>
                                <span>{sportello.orari.sabatoMattina1 ? oggettiUtili.orariPerCodice[sportello.orari.sabatoMattina1] : "//"}</span>
                            </div>
                            <div className="col-5" style={{border: "1px solid #1b7ea9", textAlign: "center"}}>
                                <span>{sportello.orari.sabatoMattina2 ? oggettiUtili.orariPerCodice[sportello.orari.sabatoMattina2] : "//"}</span>
                            </div>
                        </div>
                    </div>
                    <div className={"col-5"}>
                        <div className="row" style={{justifyContent: "space-around"}}>
                            <div className="col-5" style={{border: "1px solid #1b7ea9", textAlign: "center"}}>
                                <span>{sportello.orari.sabatoPomeriggio1 ? oggettiUtili.orariPerCodice[sportello.orari.sabatoPomeriggio1] : "//"}</span>
                            </div>
                            <div className="col-5" style={{border: "1px solid #1b7ea9", textAlign: "center"}}>
                                <span>{sportello.orari.sabatoPomeriggio2 ? oggettiUtili.orariPerCodice[sportello.orari.sabatoPomeriggio2] : "//"}</span>
                            </div>
                        </div>
                    </div>
                </Row>
            </div>:<></>}

            <div className={"row"} style={{marginTop: "1rem", marginBottom: "1rem", justifyContent: "center"}}>
                <Button
                    id={"indietro"}
                    typeButton={"White"}
                    disabled={false}
                    text={"Indietro"}
                    style={{height: "45px", width: "180px"}}
                    dataDismiss="modal"
                    onClick={onClickIndietro}
                />
            </div>
        </div>
    )


}

export default ModaleOrari